import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Save, Lock } from 'lucide-react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminSettings() {
  const { user } = useAuth();
  const [currentPass, setCurrentPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPass !== confirmPass) { toast.error('Las contraseñas no coinciden'); return; }
    if (newPass.length < 6) { toast.error('Mínimo 6 caracteres'); return; }
    setSaving(true);
    try {
      await api.put('/auth/change-password', { current_password: currentPass, new_password: newPass });
      toast.success('Contraseña actualizada');
      setCurrentPass(''); setNewPass(''); setConfirmPass('');
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 24 }}>Configuración</h1>
      <div style={{ maxWidth: 480 }}>
        <div className="card">
          <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}><Lock size={18} /> Cambiar contraseña</h3>
          <form onSubmit={handleChangePassword}>
            <div className="form-group"><label>Contraseña actual</label><input type="password" value={currentPass} onChange={e => setCurrentPass(e.target.value)} required /></div>
            <div className="form-group"><label>Nueva contraseña</label><input type="password" value={newPass} onChange={e => setNewPass(e.target.value)} required /></div>
            <div className="form-group"><label>Confirmar nueva contraseña</label><input type="password" value={confirmPass} onChange={e => setConfirmPass(e.target.value)} required /></div>
            <button type="submit" className="btn btn-primary" disabled={saving}><Save size={16} /> {saving ? 'Guardando...' : 'Guardar'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
